// extracted by mini-css-extract-plugin
module.exports = {"logo":"Login_logo__30kj8","title":"Login_title__g6im3","link":"Login_link__1SeQA","error":"Login_error__3xvcX"};